/* eslint-disable no-useless-escape */
import React, { useState } from "react";
import supabase from "../../supabase";
import {
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  ModalBody,
  Box,
  Flex,
  Heading,
  Text,
  useMediaQuery,
  Center,
  FormControl,
  FormLabel,
  Input,
  Button,
  Textarea,
  useToast
} from "@chakra-ui/react";

import Rating from "../rating/Rating";
import PropTypes from "prop-types";

const ProductModal = ({ PopUpData, handleClose }) => {
  const [isMobile] = useMediaQuery("(max-width: 820px)");
  const [formData, setFormData] = useState(PopUpData);
  const [starsRating, setStarsRating] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const toast = useToast();
  const BoxStyle = {
    boxShadow: "5px 5px 1px",
    borderStyle: "solid",
    borderColor: "black",
    borderWidth: "2px"
  };

  const handleInputChange = event => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const handleValidation = () => {
    if (formData.name && formData.email && formData.title && formData.review && starsRating) {
      const isMail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(formData.email);
      if (isMail) {
        return true;
      } else {
        setIsLoading(false);
        setErrorMessage("Maaf, anda memasukkan alamat email yang tidak valid");
        setTimeout(function () {
          setErrorMessage(null);
        }, 2000);
        return false;
      }
    } else {
      setIsLoading(false);
      setErrorMessage("Mohon lengkapi seluruh isian ulasan anda");
      setTimeout(function () {
        setErrorMessage(null);
      }, 2000);
      return false;
    }
  };

  const onSubmit = async () => {
    setIsLoading(true);
    const validation = handleValidation();

    if (validation) {
      try {
        const finalData = {
          name: formData.name,
          productsLookup: formData.productName,
          productType: formData.productType,
          noLookup: formData?.noLookup,
          email: formData.email,
          rating: starsRating,
          source: formData.source,
          products: formData.products,
          title: formData.title,
          review: formData.review,
          createdAt: formData.createdAt,
          updatedAt: formData.createdAt,
          date: formData.date,
          show: true
        };

        const { error } = await supabase.from("Product Review").insert([finalData]);
        if (!error) {
          setIsLoading(false);
          // @desc STATUS ERROR IS USED FOR RED COLOUR TOAST
          toast({
            title: "Terima kasih, ulasan anda berhasil terkirim!",
            status: "error",
            isClosable: true,
            position: "top"
          });
          handleClose();
        }
      } catch (error) {
        console.error(error);
        setIsLoading(false);
        setMessage("Terjadi kesalahan, ulasan anda belum dapat terkirim!");
        setTimeout(function () {
          setMessage(null);
        }, 1500);
      }
    }
  };

  return (
    <>
      <ModalOverlay />
      <ModalContent bgSize="100%">
        <ModalCloseButton />
        <ModalBody padding={isMobile ? "30px 20px 0px 20px" : 0}>
          <Box>
            <Flex direction="row">
              <Box w="100%" p="30px" alignItems="center">
                <Heading mb={6} as="h3" size="md">
                  Tambahkan Ulasan Anda
                </Heading>
                <FormControl mb="3">
                  <FormLabel htmlFor="name">Nama</FormLabel>
                  <Input id="name" name="name" type="text" onChange={handleInputChange} />
                </FormControl>
                <FormControl mb="3">
                  <FormLabel htmlFor="email">Alamat Email</FormLabel>
                  <Input id="email" name="email" type="email" onChange={handleInputChange} />
                </FormControl>
                <Rating
                  size={28}
                  scale={5}
                  fillColor="gold"
                  strokeColor="gold"
                  setStarsRating={setStarsRating}
                />
                <FormControl mb="3">
                  <FormLabel htmlFor="title">Judul Ulasan</FormLabel>
                  <Input id="title" name="title" type="text" onChange={handleInputChange} />
                </FormControl>
                <FormControl mb="6">
                  <FormLabel htmlFor="review">Ulasan Anda</FormLabel>
                  <Textarea id="review" name="review" size="lg" onChange={handleInputChange} />
                </FormControl>
                <Center bg="white" height="50px" style={BoxStyle}>
                  <Button
                    bg="white"
                    w="100%"
                    onClick={onSubmit}
                    isLoading={isLoading}
                    loadingText="Mengirimkan ulasan..."
                    spinnerPlacement="start">
                    Kirim Ulasan
                  </Button>
                </Center>
                <Center>
                  <Text mb="4" mt="4" color="black" fontSize="lg">
                    {message}
                  </Text>
                  {errorMessage && (
                    <Text mb="4" mt="4" color="red.700" fontSize="lg">
                      {errorMessage}
                    </Text>
                  )}
                </Center>
              </Box>
            </Flex>
          </Box>
        </ModalBody>
      </ModalContent>
    </>
  );
};

ProductModal.propTypes = {
  PopUpData: PropTypes.instanceOf(Object)
};

ProductModal.defaultProps = {
  PopUpData: {}
};

export default ProductModal;
